import React from 'react';


export const StageConduct = function({ planData, updateData }) {

  return (

          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium mb-2">Introducing New Partners to Children</label>
              <div className="space-y-2">
                {[
                  { id: '3months', name: '3-Month Relationship Minimum', desc: 'New partners not introduced until relationship is at least 3 months' },
                  { id: '6months', name: '6-Month Relationship Minimum', desc: 'New partners not introduced until relationship is at least 6 months' },
                  { id: 'engaged', name: 'Only If Engaged / Committed', desc: 'Introductions only when the relationship is committed' },
                  { id: 'notify', name: 'Notify Other Parent First', desc: 'Give notice before introducing a new partner' },
                  { id: 'no-restriction', name: 'No Restriction', desc: 'Each parent decides at their discretion' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('introNewPartner', opt.id); }}
                      className={planData.introNewPartner === opt.id
                        ? 'w-full p-3 rounded-lg border text-left border-[#2D2560] bg-[#2D2560]/10'
                        : 'w-full p-3 rounded-lg border text-left border-white/10 hover:border-white/20'}>
                      <p className="font-medium text-sm">{opt.name}</p>
                      <p className="text-xs text-white/50">{opt.desc}</p>
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">New Partner Overnight Presence</label>
              <p className="text-xs text-white/40 mb-3">When can a new partner be present during overnights while the child is in the home?</p>
              <div className="space-y-2">
                {[
                  { id: 'not-until-intro', name: 'Not Until Properly Introduced', desc: 'New partner may not stay overnight until the child has been formally introduced per the rules above' },
                  { id: '6months-dating', name: 'After 6 Months of Dating', desc: 'Overnights permitted after the relationship has lasted at least 6 months' },
                  { id: 'engaged-only', name: 'Only If Engaged or Cohabiting', desc: 'Overnights only when the relationship has reached engagement or cohabitation' },
                  { id: 'never', name: 'Not While Child Is Present', desc: 'New partners may not stay overnight when the child is in the home' },
                  { id: 'no-restriction', name: 'No Restriction', desc: 'Each parent decides at their discretion' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('newPartnerOvernights', opt.id); }}
                      className={planData.newPartnerOvernights === opt.id
                        ? 'w-full p-3 rounded-lg border text-left border-[#2D2560] bg-[#2D2560]/10'
                        : 'w-full p-3 rounded-lg border text-left border-white/10 hover:border-white/20'}
                      data-testid={'partner-overnight-' + opt.id}>
                      <p className="font-medium text-sm">{opt.name}</p>
                      <p className="text-xs text-white/50">{opt.desc}</p>
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Child&apos;s Image on Dating Profiles</label>
              <p className="text-xs text-white/40 mb-3">Can a parent post the child&apos;s photo or likeness on dating sites or apps?</p>
              <div className="grid grid-cols-3 gap-2">
                {[
                  { id: 'restricted', label: 'Not Allowed' },
                  { id: 'allowed', label: 'Allowed' },
                  { id: 'no-restriction', label: 'No Restriction' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('datingProfileChild', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.datingProfileChild === opt.id ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}
                      data-testid={'dating-profile-' + opt.id}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Social Media Policy Regarding Children</label>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { id: 'no-posting', label: 'No Posting Children' },
                  { id: 'consent', label: 'Mutual Consent Required' },
                  { id: 'limited', label: 'Limited / Private Only' },
                  { id: 'no-restriction', label: 'No Restriction' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('socialMediaPolicy', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.socialMediaPolicy === opt.id ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Non-Disparagement Clause</label>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { id: 'no-disparagement', label: 'Full Non-Disparagement' },
                  { id: 'mutual-respect', label: 'Mutual Respect Agreement' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('disparagement', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.disparagement === opt.id ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Substance Use Policy During Parenting Time</label>
              <div className="grid grid-cols-3 gap-2">
                {[
                  { id: 'no-use', label: 'No Use During Time' },
                  { id: 'no-impairment', label: 'No Impairment' },
                  { id: 'no-restriction', label: 'No Restriction' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('substancePolicy', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.substancePolicy === opt.id ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Alcohol Policy During Parenting Time</label>
              <div className="grid grid-cols-3 gap-2">
                {[
                  { id: 'no-alcohol', label: 'No Alcohol During Time' },
                  { id: 'no-intoxication', label: 'No Intoxication' },
                  { id: 'no-restriction', label: 'No Restriction' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('alcoholPolicy', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.alcoholPolicy === opt.id ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}
                      data-testid={'alcohol-' + opt.id}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="card-surface p-5 space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">Drug or Alcohol Monitoring Required?</label>
                <div className="grid grid-cols-2 gap-2">
                  {[
                    { id: 'yes', label: 'Yes' },
                    { id: 'no', label: 'No' },
                  ].map(function(opt) {
                    return (
                      <button key={opt.id} onClick={function() { updateData('substanceMonitoring', opt.id); }}
                        className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                          (planData.substanceMonitoring === opt.id ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}
                        data-testid={'monitoring-' + opt.id}>
                        {opt.label}
                      </button>
                    );
                  })}
                </div>
              </div>

              {planData.substanceMonitoring === 'yes' && (
                <div>
                  <label className="block text-sm font-medium mb-2">Monitoring Frequency</label>
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                    {[
                      { id: 'once-week', label: 'Once a Week' },
                      { id: 'twice-week', label: 'Twice a Week' },
                      { id: 'random', label: 'Random Testing' },
                      { id: 'monthly', label: 'Monthly' },
                    ].map(function(opt) {
                      return (
                        <button key={opt.id} onClick={function() { updateData('monitoringFrequency', opt.id); }}
                          className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                            (planData.monitoringFrequency === opt.id ? 'border-[#2D2560] bg-[#2D2560]/10' : 'border-white/10 hover:border-white/20')}
                          data-testid={'monitoring-freq-' + opt.id}>
                          {opt.label}
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}

              {planData.substanceMonitoring === 'yes' && (
                <div>
                  <label className="block text-sm font-medium mb-2">Monitoring Type</label>
                  <div className="space-y-2">
                    {[
                      { id: 'at-home', name: 'At-Home Testing', desc: 'Self-administered tests at home with results shared' },
                      { id: 'professional', name: 'Professionally Monitored', desc: 'Tests administered and monitored by a licensed facility or professional' },
                      { id: 'court-ordered', name: 'Court-Ordered Program', desc: 'Monitoring through a court-ordered substance abuse program' },
                    ].map(function(opt) {
                      return (
                        <button key={opt.id} onClick={function() { updateData('monitoringType', opt.id); }}
                          className={planData.monitoringType === opt.id
                            ? 'w-full p-3 rounded-lg border text-left border-[#2D2560] bg-[#2D2560]/10'
                            : 'w-full p-3 rounded-lg border text-left border-white/10 hover:border-white/20'}
                          data-testid={'monitoring-type-' + opt.id}>
                          <p className="font-medium text-sm">{opt.name}</p>
                          <p className="text-xs text-white/50">{opt.desc}</p>
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        
  );
};
